// Mascote Conecta 3D (MPires Connect).
// Ver PEDIDO_EMERGENT_CONECTA_3D.md — substituímos o SVG inline pelas
// artes 3D em /public/mascote/. Usamos <picture> com WebP + fallback PNG,
// e as animações permanecem 100% CSS (classes em index.css).

function ConectaImagem({ width, height, alt, variante = "principal", className }) {
  const base = variante === "icone" ? "/mascote/conecta-3d-icone" : "/mascote/conecta-3d";
  return (
    <picture>
      <source srcSet={`${base}.webp`} type="image/webp" />
      <img
        src={`${base}.png`}
        alt={alt}
        width={width}
        height={height}
        draggable={false}
        style={{ width, height, objectFit: "contain", display: "block", userSelect: "none" }}
        className={className}
      />
    </picture>
  );
}

export function ConectaAcenando({ width = 200, height = 240, className }) {
  return (
    <ConectaImagem
      width={width}
      height={height}
      alt="Conecta, mascote do MPires Connect, acenando"
      className={className}
    />
  );
}

export function ConectaComemorando({ width = 200, height = 240, className }) {
  return (
    <ConectaImagem
      width={width}
      height={height}
      alt="Conecta, mascote do MPires Connect, comemorando"
      className={className}
    />
  );
}

export function ConectaIcone({ width = 40, height = 40, className }) {
  return (
    <ConectaImagem
      width={width}
      height={height}
      variante="icone"
      alt="Conecta"
      className={className}
    />
  );
}
